export default __webpack_public_path__ + "static/media/book.b1e72897.jpg";